import achievements from './achievements';
import common from './common';
import navigation from './navigation';
import recommendations from './recommendations';
import settings from './settings';
import pages from './pages';

export default [
  achievements,
  common,
  navigation,
  recommendations,
  settings,
  pages,
].join('');